import { serializeFarm } from './helpers'
import { SerializedFarmConfig } from './types'

// Farm pid should start from chain id

const farms: SerializedFarmConfig[] = [].map(serializeFarm)

export default farms
